<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div>
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}</b-button>
			</div>
		</div>
		<b-card class="mt-3 p-3">
			<div class="text-center mt-3">
				<h3 class="font-weight-bold text-uppercase">
					{{ $t(item.documentType) }} №: <span class="small">{{ item.regNumber }}</span>
				</h3>
			</div>
			<div id="tableTopActions" class="d-flex align-items-center mt-3 position-relative">
				<div class="card-header-actions justify-content-start">
					<div class="searchInCard">
						<b-input-group size="sm">
							<b-form-input v-model="payload.keyword" size="sm" :placeholder="$t('contragent.filter')"
								autocomplete="off" @input="getList" />
							<b-input-group-append>
								<b-button :disabled="!payload.keyword" @click="clearSearchItem">{{
									$t('contragent.clear') }}</b-button>
							</b-input-group-append>
						</b-input-group>
					</div>
				</div>
				<div class="justify-content-end">
					<b-form-group class="pull-right mb-0">
						<b-form-radio-group id="btn-radios-2" v-model="countType" :options="types" buttons
							button-variant="outline-primary" size="sm" name="radio-btn-outline"></b-form-radio-group>
					</b-form-group>
					<div class="clearfix"></div>
				</div>
				<div class="actions justify-content-end position-absolute" style="right: 0">
					<b-row>
						<b-col cols="12" class="text-right">
							<b-button @click="pendingModal = !pendingModal" variant="outline-warning" class="ml-2">
								Возврат всё
							</b-button>
							<!--							<b-button @click="checkAndSave('off')" variant="outline-danger" class="ml-2">-->
							<!--								{{ $t('pending.off') }}-->
							<!--							</b-button>-->
							<!--							<b-button @click="checkAndSave('save')" v-if="$can('receive', 'check warehouse transfer pending document')" variant="success" class="ml-2">{{ $t('pending.save') }}</b-button>-->
							<b-button v-if="$can('view', 'accept-transfer-document')" @click="transferModal = true"
								variant="success" class="ml-2">Принимать всё</b-button>
						</b-col>
					</b-row>
				</div>
			</div>
			<table class="table table-hover table-bordered table-striped mt-3" id="my-table">
				<thead>
					<tr>
						<th class="alignCenter">№</th>
						<th>Товар</th>
						<th class="text-center">{{ $t('pricing.costNumber') }}</th>
						<th class="text-center">{{ $t('goods.create.special-barcode') }}</th>
						<th class="text-center">{{ $t('goods.barcode') }}</th>
						<th class="text-center">{{ $t('kirim.expirationDate') }}</th>
						<th class="text-center">{{ $t('incomes.create.price') }}</th>
						<th class="alignCenter">{{ $t('incomes.create.count') }}</th>
						<th class="alignCenter">{{ $t('incomes.create.count') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(income, index) in incomes">
						<td class="alignCenter">{{ paginate(index, payload.page, payload.limit) }}</td>
						<td>
							<h6>{{ income.itemName ? income.itemName : '' }}</h6>
						</td>
						<td class="text-center">{{ income.incomeParentRegNumber }}</td>
						<td class="text-center">{{ income.barcode }}</td>
						<td class="text-center">
							<span v-for="barcode in income.multiBarcodesString">
								{{ barcode }}
							</span>
						</td>
						<td class="text-center">{{ income.termOfItem ? income.termOfItem : '-' }}</td>
						<td class="text-center">{{ income.priceUzs ? income.priceUzs : '-' }}</td>
						<td class="alignCenter">
							<h6>{{ income.count }} {{ income.unitName }}</h6>
						</td>
						<td class="w-300">
							<span class="w-24p text-center">
								<span class="text-danger" v-if="incomes[index].changed && checkIsKam(index)">
									<i class="fa fa-question-circle"></i>
								</span>
								<span class="text-danger" v-if="incomes[index].changed && checkIsKop(index)">
									<i class="fa fa-question-circle"></i>
								</span>
								<span class="text-success" v-if="incomes[index].changed && checkIsTeng(index)">
									<i class="fa fa-check"></i>
								</span>
							</span>
							<div class="w-75p">
								<b-input-group size="sm">
									<b-input v-model="income.temporaryQty" :disabled="isBarcode" type="number" min="0"
										@blur="setTemporaryQty(income, index)" @keydown="keydown(index)"></b-input>
									<b-input-group-addon>
										<b-button disabled size="sm">{{ income.unitName }}</b-button>
									</b-input-group-addon>
								</b-input-group>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<nav>
				<b-pagination :total-rows="item.totalPage" :per-page="payload.limit" v-model="payload.page"
					aria-controls="my-table" />
			</nav>
			<div v-if="loading" class="spinner-wrapper">
				<b-spinner variant="primary"></b-spinner>
			</div>
		</b-card>
		<b-modal :hide-footer="true" @close="spisatModal = false" title="Списать" size="xl" v-model="spisatModal">
			<div v-if="spisatModal">
				<spisat :document-id="item.id" @cancel="spisatModal = false" @ok="spisatAction"
					:items="collectAdjustment"></spisat>
			</div>
		</b-modal>
		<b-modal v-model="pendingModal" @ok="returnPending" ok-title="Да" cancel-title="Отмена">
			<h4>Возврат?</h4>
		</b-modal>

		<b-modal v-model="transferModal" hide-footer ok-title="save">
			<div slot="modal-header">
				<h5 slot="modal-title" class="mb-0">
					Пароль
				</h5>
			</div>
			<div style="margin: 25px;">
				<b-form-group label-for="transferAcceptPassword" size="sm">
					<b-input-group-prepend>
						<span class="input-group-text"><i class="fa fa-key"></i></span>
						<b-form-input size="sm" :placeholder="'Пароль для перемещения'" type="password"
							id="transferAcceptPassword" v-model="currentItem.transferAcceptPassword" />
					</b-input-group-prepend>
				</b-form-group>

				<div class="row top mt-3 justify-content-end">
					<div class="col-4">
						<b-button size="sm" variant="outline-danger" block @click="closeTransferModal">{{
							$t('actions.cancel') }}
						</b-button>
					</div>
					<div class="col-4">
						<b-button size="sm" variant="outline-success" block @click="saveAllItemsNew"
							:disabled="currentItem.transferAcceptPassword.length < 1">
							Принимать всё
						</b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</b-container>
</template>

<script>
import EmployeeSerive from "@/services/employees.service";
import {TokenService} from "@/services/storage.service";
import WhDocument from "@/services/wh-document.service";
import GoodsService from "@/services/goods.service";
import { convertRuToEn } from "@/utils/helper";
import { mapActions } from 'vuex'


export default {
	name: "Pending",
	data() {
		return {
			payload: {
				page: 1,
				limit: 20,
				keyword: ''
			},

			currentItem: {
				transferAcceptPassword: ''
			},

			item: {},
			incomes: [],
			loading: false,
			spisatModal: false,
			pendingModal: false,
			countType: 'Штрихкод',
			transferModal: false,
			openReturnItemModal: false,
			types: ['Штрихкод', 'Ручной'],
		}
	},
	methods: {
		...mapActions('warehouse', [
			'returnPendingAction'
		]),
		closeTransferModal() {
			this.transferModal = false
			this.currentItem.transferAcceptPassword = ''
		},
		closeReturnModal() {
			this.openReturnItemModal = false;
		},
		openReturnItems() {
			this.openReturnItemModal = true;
		},
		goBackToFrom() {
			this.$router.back();
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		keydown(index) {
			this.incomes[index].changed = true
		},
		clearSearchItem() {
			this.payload.keyword = ''
			this.getList();
		},
		checkIsKam(index) {
			return (this.incomes[index].count > this.incomes[index].temporaryQty);
		},
		checkIsKop(index) {
			return (this.incomes[index].count < this.incomes[index].temporaryQty);
		},
		checkIsTeng(index) {
			return this.incomes[index].count === parseFloat(this.incomes[index].temporaryQty);
		},
		getList() {
			return WhDocument.getPendingList(this.$route.params.id, this.payload).then(response => {
				this.item = response.data
				if (this.item.documentStatus === 'READY') {
					this.$router.push(`/warehouse-management/transfers`)
				}
				this.incomes = this.item.whItems;
				this.incomes.forEach((t, index) => {
					if (t.temporaryQty != 0) {
						t.changed = true
					}
				})
				this.loading = false
			}).catch(e => {
				console.log(e)
				this.loading = false
			})
		},
		setTemporaryQty(item, index) {
			this.incomes[index].changed = true
			WhDocument.setTemporaryQty(item).then(res => {
			}).catch(e => {
				this.$vs.notify({
					text: 'Штрих-код не найдено!',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		onBarcodeScanned(barcodeNum) {
			let barcode = convertRuToEn(barcodeNum)
			if (this.isBarcode) {
				GoodsService.pendingByBarcode(this.$route.params.id, barcode).then(response => {
					const income = this.findIncome(response);
					if (income) {
						this.incomes.unshift(response)
						this.incomes[this.incomes.indexOf(response)].changed = true;
					} else {
						this.incomes.splice(19, 1)
						this.incomes.unshift(response)
						this.incomes[this.incomes.indexOf(response)].changed = true;
					}
				}).catch(e => {
					this.$vs.notify({
						text: 'Штрих-код не найдено!',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		},
		findIncome(response) {
			return this.incomes.find((item) => {
				if (item.itemId === response.itemId) {
					this.incomes.splice(this.incomes.indexOf(item), 1)
					return response;
				}
			})
		},
		confirmation(message) {
			return new Promise((resolve, reject) => {
				this.$bvModal
					.msgBoxConfirm(`${message}`, {
						title: 'Пожалуйста подтвердите !',
						size: 'sm',
						buttonSize: 'sm',
						cancelVariant: 'danger',
						okVariant: 'success',
						okTitle: this.$t('words.yes'),
						cancelTitle: this.$t('words.no'),
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true,
					})
					.then(value => {
						resolve(value)
					})
					.catch(err => {
						reject()
					});
			})
		},
		checkAndSave(pending) {
			if (pending == 'save') {
				setTimeout(() => {
					WhDocument.getConfirmMessagePending(this.$route.params.id).then(res => {
						if (res.data.code == 0) {
							this.$vs.notify({
								title: `${res.data.message}`,
								color: 'danger',
								icon: 'close',
								progress: true,
								position: 'top-right'
							})
						} else if (res.data.code == 1) {
							this.confirmation(res.data.message).then(t => {
								if (t) {
									WhDocument.savePendingPartial(this.$route.params.id).then(res => {
										if (res.data) {
											this.$router.go(-1);
											this.$vs.notify({
												title: `success saved`,
												color: 'success',
												icon: 'close',
												position: 'top-right',
												progress: 'auto',
											})
										} else {
											this.$vs.notify({
												title: `error`,
												color: 'danger',
												icon: 'close',
												position: 'top-right',
												progress: true,
											})
										}
									})
								}
							})
						} else if (res.data.code == 2) {
							this.confirmation(res.data.message).then(t => {
								if (t) {
									WhDocument.savePendingPrinyat(this.$route.params.id).then(res => {
										if (res.data) {
											this.$router.go(-1);
											this.$vs.notify({
												title: `success saved`,
												color: 'success',
												icon: 'close',
												position: 'top-right',
												progress: 'auto',
											})
										} else {
											this.$vs.notify({
												title: `error`,
												color: 'danger',
												icon: 'close',
												position: 'top-right',
												progress: true,
											})
										}
									})
								}
							})
						} else {
							this.$vs.notify({
								title: `${res.data.message}`,
								color: 'danger',
								icon: 'close',
								progress: 'auto',
								position: 'top-right'
							})
						}
					}).catch(e => {
						console.log(e)
					})
				}, 500)
			} else if (pending == 'off') {
				this.spisatModal = true
			}
		},
		spisatAction() {
		},
		async returnPending() {
			await this.returnPendingAction(this.$route.params.id);
			this.openReturnItemModal = false;
			this.$router.back();
		},
		saveAllItems() {
			this.$bvModal.msgBoxConfirm('Вы действительно хотите принимать все товары ?', {
				title: 'Подтверждать',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'Да',
				cancelVariant: 'danger',
				cancelTitle: 'Нет',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					WhDocument.saveAllPendingItems(this.$route.params.id).then(res => {
						this.$router.push(`/warehouse-management/transfers/view/${this.$route.params.id}`);
						this.$vs.notify({
							title: 'Success',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					}).catch(err => {
						this.$vs.notify({
							title: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				}
			}).catch(err => {
				this.$vs.notify({
					title: err.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		saveAllItemsNew() {
			if (this.currentItem.transferAcceptPassword) {
				EmployeeSerive.verifyTransferPassword(TokenService.getCurrentUserId(), this.currentItem).then(res => {
					WhDocument.saveAllPendingItems(this.$route.params.id).then(res => {
						this.$router.push(`/warehouse-management/transfers/view/${this.$route.params.id}`);
						this.$vs.notify({
							title: 'Success',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					}).catch(err => {
						this.$vs.notify({
							title: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				}).catch(err => {
					this.$vs.notify({
						title: err.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			}
		}
	},
	computed: {
		isBarcode() {
			return this.countType === 'Штрихкод';
		},
	},
	watch: {
		'payload.page': {
			handler() {
				this.getList();
			}
		}
	},
	created() {
		this.loading = true
		this.getList();
		this.$barcodeScanner.init(this.onBarcodeScanned);
	}
}
</script>

<style scoped>
.w-300 {
	width: 300px;
}

.w-75p {
	width: 75%;
	display: inline-block;
}

.w-24p {
	width: 24%;
	display: inline-block;
	font-size: 20px;
}

.alignCenter {
	text-align: center;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
